import script from "./biaogan.vue?vue&type=script&setup=true&lang=js"
export * from "./biaogan.vue?vue&type=script&setup=true&lang=js"

import "./biaogan.vue?vue&type=style&index=0&id=48cfab46&lang=less&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48cfab46"]])

export default __exports__